import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.0894 4.41076C12.764 4.08533 12.2363 4.08533 11.9109 4.41076L6.91091 9.41077C6.58547 9.7362 6.58547 10.2638 6.91091 10.5893L11.9109 15.5893C12.2363 15.9147 12.764 15.9147 13.0894 15.5893C13.4149 15.2638 13.4149 14.7362 13.0894 14.4108L8.67867 10L13.0894 5.58928C13.4149 5.26384 13.4149 4.7362 13.0894 4.41076Z",
		fill: "url(#paint0_linear_prev)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_prev",
		x1: 6.84227,
		y1: -11.0897,
		x2: 14.018,
		y2: -10.8914,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#616CE0" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#4B8DEA"
		})]
	}) })]
});
export default SvgChevronLeft;
